import { root } from './resend';

export const resend = {
  ...root,
};
